<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yrRlLl/tc-custom/9781504087674.jpg?1740440977604" alt="This image is the cover for the book Garden of Prayer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Garden of Prayer
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An exquisitely illustrated collection of more than 100 beautiful prayers drawn from centuries of Christian faith across the globe.</b></p><p> Chosen for their poetry as well as their enduring power to inspire, the prayers collected in this volume reflect the historical and cultural breadth of the Christian tradition. The selection includes prayers from four continents and many centuries—composed in the flower of youth and the fullness of maturity, uttered in sorrow, thanksgiving, doubt, and transcendence. </p><p><i>A Garden of Prayer</i> brings together the words of Saints, including Thomas Aquinas and Francis of Assisi, as well as authors ranging from Abraham Lincoln to Thomas Merton and from John Donne to Robert Louis Stevenson. It also features powerful, anonymous prayers from the Christian communities of Ghana, Ireland, and elsewhere. </p> The prayers are arranged in five sections that correspond to the changing seasons—spring, summer, fall, winter, and returns to the transcendent spring. The beauty of the prayers is enhanced by illustrations throughout the book, including full-color illuminations that begin each section.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jenna Bassin, Jane Lahr
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Philosophical Library/Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7736cc6c